import './welcome.scss';
import WizardInfo from '../../blocks/wizard-info/wizard-info';

class WelcomeController {
  /*@ngInject*/
  constructor($location, wizardInfo) {
    this.wizardInfo = wizardInfo;
    this.$location = $location;

    if (!this.isUpgradeAvailable()) {
      this.redirect('/install/base');
    }

    if (this.shouldUpgrade()) {
      this.redirect('/upgrade/settings');
    }

    if (this.shouldManageUpgradeSource()) {
      this.redirect('/upgrade/source');
    }
  }

  redirect(path) {
    this.$location.path(path);
  }

  isUpgradeAvailable() {
    return this.wizardInfo.isUpgradeAvailable;
  }

  shouldUpgrade() {
    return this.wizardInfo.isUpgradeDetected && this.wizardInfo.isDetectedUpgradeSourceValid;
  }

  shouldManageUpgradeSource() {
    return this.wizardInfo.isUpgradeDetected && !this.wizardInfo.isDetectedUpgradeSourceValid;
  }

  getInstallationTitle() {
    return this.wizardInfo.productPresentationName;
  }
}

export default angular.module('installer.welcome', [WizardInfo.name]).
  controller('WelcomeController', WelcomeController).
  config($routeProvider => {
    $routeProvider.
      when('/welcome', {
        template: require('./welcome.html'),
        controller: 'WelcomeController as ctrl'
      });
  });



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.js